<!--
	日期：2025/09/25
	地点：四川 成都
	作者：终结司令官
	
	介绍：注册社区合伙人
	
	- Powered by finalcommander.com
	- Supported by IOE.TOP
-->
<template>
	<div id="app-regpartner" class="app-regpartner">

		<myLegalNotice :mln_id="'forreg'" :force-confirm="true"></myLegalNotice>
		<!-- 上传中 -->
		<el-dialog
		  title="上传中"
		  ref="Uploading"
		  :visible.sync="dialogVisibleUploading"
		  :before-close="Uploading_handleClose">
			<template v-if="filesOnUploading && filesOnUploading.length">
			  <div v-for="(item, index) in filesOnUploading" 
				:key="index">
				<span v-if="item && item.name">
					<i class="el-icon-loading"/> 
					<span style="font-weight:bold;padding-left:5px;">
						{{ item.name }} 
					</span>
					<span style="color:#d0d0d0;padding-left:10px;">
						{{ (fileOnUploading.size/1024/1024).toFixed(2) }} MB
					</span>
			    </span>
				<span v-if="fileOnUploading.name == item.name">
					<span style="color:#d0d0d0;padding-left:10px;">传输中 ...</span>
				</span>
			  </div>
			</template>
		</el-dialog>
		
		<center>
		  <div style="margin:20px;text-align:left;cursor:pointer;" @click="go2url()"><i class="el-icon-d-arrow-left"/> 返回</div>
		  <div slot="header" class="clearfix">
			<div>美好生活 v1.0</div>
			<span>社区合伙人注册登记</span>
		  </div>
		  <div class="regbox">
			<el-form ref="modifyFormOtherInfo" :inline="true" :rules="rules" :model="userInfo_cols">
			  <el-form-item label="姓名" prop='realname' style="margin-right:0px;">
				<el-input v-model="userInfo_cols.realname" class="input-item" placeholder="请输入 ..."></el-input>
			  </el-form-item>
			  <el-form-item label="联系电话" prop='tel1' style="margin-right:0px;">
				<el-input v-model="userInfo_cols.tel1" class="input-item" placeholder="请输入 ..."></el-input>
			  </el-form-item>
			  <el-form-item label="备用电话" prop='tel2' style="margin-right:0px;">
				<el-input v-model="userInfo_cols.tel2" class="input-item" placeholder="请输入 ..."></el-input>
			  </el-form-item>
			  <hr style="border:1px solid #e0e0e0;margin-bottom:25px;">
			  <el-form-item label="身份证号" prop='idcard' style="margin-right:0px;">
				<el-input v-model="userInfo_cols.idcard" class="input-item" placeholder="请输入 ..."></el-input>
			  </el-form-item>
			  <el-form-item label="家庭住址" prop='address' style="margin-right:0px;">
				<el-input v-model="userInfo_cols.address" class="input-item" placeholder="请输入 ..."></el-input>
			  </el-form-item>
			  <el-form-item label="工作单位" prop='cop' style="margin-right:0px;">
				<el-input v-model="userInfo_cols.cop" class="input-item" placeholder="请输入 ..."></el-input>
			  </el-form-item>
			  <el-form-item label="单位地址" prop='cop_address' style="margin-right:0px;">
				<el-input v-model="userInfo_cols.cop_address" class="input-item" placeholder="请输入 ..."></el-input>
			  </el-form-item>
			  <el-form-item label="身份证复印件" prop='idcard_files' style="margin-right:0px;">
				<el-upload
				  class="upload-demo"
				  :action="get_IOETOP_BaseUrl() + '/open/api/2.0.1/upload/file/' + get_username_at()"
				  :on-preview="other_idcard_files_handleFilePreview"
				  :on-remove="other_idcard_files_handleFileRemove"
				  :on-success="other_idcard_files_handleFileSuccess"
				  :before-remove="other_idcard_files_beforeFileRemove"
				  :before-upload="other_idcard_files_beforeUpload"
				  multiple
				  :limit="5"
				  :on-exceed="other_idcard_files_handleFileExceed"
				  :file-list="userInfo_cols.idcard_files">
				  <el-button size="small" type="primary">点击上传</el-button>
				  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb
				  </div>
				</el-upload>
			  </el-form-item>
			  <el-form-item label="备注" prop='remark' style="margin-right:0px;">
				<el-input 
					v-model="userInfo_cols.remark" 
					class="inputtextarea-item" 
					type="textarea"
					:rows="5"
					placeholder="请输入文字"></el-input>
			  </el-form-item>
			  <el-form-item label="附件" prop='files' style="margin-right:0px;">
				<el-upload
				  class="upload-demo"
				  :action="get_IOETOP_BaseUrl() + '/open/api/2.0.1/upload/file/' + get_username_at()"
				  :on-preview="other_files_handleFilePreview"
				  :on-remove="other_files_handleFileRemove"
				  :on-success="other_files_handleFileSuccess"
				  :before-remove="other_files_beforeFileRemove"
				  :before-upload="other_files_beforeUpload"
				  multiple
				  :limit="5"
				  :on-exceed="other_files_handleFileExceed"
				  :file-list="userInfo_cols.files">
				  <el-button size="small" type="primary">点击上传</el-button>
				  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb
				  </div>
				</el-upload>
			  </el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="go2url()">关 闭</el-button>
				<el-button type="primary" @click="submitForm('modifyFormOtherInfo')">确 定</el-button>
			</div>
		  </div>
		</center>
	</div>
</template>

<script>
import myLegalNotice from '../components/LegalNotice.vue'
import { getQuery, getQueryNull, getDownloadURL, loginWXUser } from '../api/'
export default {
	name: 'app-regpartner',
	components: {
		myLegalNotice,
	},
	data() { 
		return {
			// 用户信息
			userInfo: {},
			dialogVisibleUploading: false,
			fileOnUploading: false,
			filesOnUploading: [],
			from: "",
			at: "",
			// 默认用户信息表
			defaultInfo_cols: {
				idcard: "",
				address: "",
				cop: "",
				cop_address: "",
				remark: "",
				files: [],
				idcard_files: [],
			},
			// 登记信息表
			userInfo_cols: {
				idcard: "",
				address: "",
				cop: "",
				cop_address: "",
				remark: "",
				files: [],
				idcard_files: [],
			},
			// 补充信息登记 form 元素
			dialogVisibleOtherInfo: false,
			dialogUserInfoActive: true,
			// 校验规则
			rules: {
				username: [
					{ required: true, message: "请选择菜单显示设置，不可以为空！", trigger: 'blur'},
					{ min: 2, max: 48, message: "长度必须为 2 到 5个字符！", trigger: 'blur'},
				],
				realname: [
					{ required: true, message: "请选择图标设置，不可以为空！", trigger: 'blur'},
					{ min: 2, max: 48, message: "长度必须为 2 到 5个字符！", trigger: 'blur'},
				],
				password: [
					{ required: true, message: "请输入密码，不可以为空！", trigger: 'blur'},
					{ min: 6, max: 30, message: "长度必须为 6 到 30个字符！", trigger: 'blur'},
				],
				accesscode: [
					{ min: 32, max: 128, message: "长度必须为 32 到 128个字符！", trigger: 'blur'},
				],
				tel1: [
					{ min: 6, max: 15, message: "长度必须为 6 到 15个字符！", trigger: 'blur'},
				],
				tel2: [
				],
			},
	}},
	state: {
	},
	mounted() {
		//this.get_myInfo();
		
        // 模拟从URL参数获取来源页面
        //const urlParams = new URLSearchParams(window.location.search);
        //this.at = urlParams.get('at');
		this.at = this.$utils.getUrlParam('at');
        //this.from = urlParams.get('from');
		this.from = this.$utils.getUrlParam('from');
		//localStorage.setItem('curWXLogin',at);
		
		localStorage.setItem('from',this.from);
		loginWXUser("regPartner", this.at, this.from);
	},
	methods: {
		// 获得IOETOP业务服务器
		get_IOETOP_BaseUrl()
		{
			return this.$utils.getBaseUrl(true,false,false,3);
		},
		// go2url
		go2url(url="/") {
			location.href = url;
		},
		// 文件下载组件
		getDownloadURL(url,domainname = null) {
			return getDownloadURL(url,domainname);
		},
		// 检测设备类型
		checkIsMobile() {
			this.isMobile = window.innerWidth <= 768;
			window.addEventListener('resize', () => {
				this.isMobile = window.innerWidth <= 768;
			});
		},
		get_username_at() {
			// 验证登陆状态
			let u = this.$utils.fun_is_online();
			let ua = 'u/' + u.username + "/a/" + u.at;
			//console.log(ua);
			return ua;
		},
		gethttporhttps() {
			return window.location.protocol;
		},
		// 关闭按钮触发
		handleClose(done) {
			this.$confirm('确认关闭？')
			.then(_ => {
				this.closeForm("");
				done();
			})
			.catch(_ => {});
		},
		Uploading_handleClose (done) {
			this.dialogVisibleUploading = false;
			this.filesOnUploading = []; 
		},
		// 关闭添加窗口操作
		closeForm(formName) {
			this.dialogVisibleOtherInfo = false;
			this.dialogVisibleStaffInfo = false,
			this.dialogVisiblePartnerInfo = false,
			this.dialogVisibleVenderInfo = false,
			this.$refs[formName].resetFields();
			this.resetFormData();
		},
		// 提交按钮
		submitForm(formName) {
			//console.log("formName:",formName);
			this.$refs[formName].validate((valid) => {
				// 提交校验正确
				if (valid) {
					if(formName === 'modifyFormOtherInfo')
					{
						let params = {};
						//params.col = "id";
						//params.id = this.formUserInfo_cols.id;
						//params.cols = this.formUserInfo_cols;
						params.cols = {};
						params.cols.info = {};
						params.cols.type = "partner";
						params.cols.realname = this.userInfo_cols.realname;
						params.cols.username = this.userInfo_cols.realname;
						params.cols.tel1 = this.userInfo_cols.tel1;
						params.cols.tel2 = this.userInfo_cols.tel2;
						params.cols.info = this.userInfo_cols;
						params.cols.from_openid = this.from;
						params.wx = this.at;
						//if(this.fileList) if(this.fileList.length>0) params.cols.files = this.fileList;
						delete params.cols.id;
						let jres = getQueryNull("login","reg",params);
						
						if(jres)
						{
							if(jres.state == 9 || jres.state == "9")
							{
								this.$message({
									type: 'error',
									message: jres.message
								}); 
							}
							else
							{
								this.$message({
									type: 'success',
									message: jres.message
								}); 
								alert(jres.message);
								location.href = "/";
							} 
						
							const thisobj = this;
							setTimeout(function() {
								//thisobj.get_myInfo();
							},100);
						}
						else
						{
							this.$message({
								type: 'error',
								message: '信息登记失败！'
							});  
						}
					}
					else 
					{
						this.$message({
							type: 'error',
							message: '提交信息失败！'
						}); 
					} 
					
					//this.closeForm(formName);
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		// 重置按钮
		resetForm(formName) {
			this.$refs[formName].resetFields();
			//this.resetFormData();
		},
		// 重置表单数据
		resetFormData() {
		},
		get_filelist(list) {
			let res = "";
			list.forEach(item => {
				res = res + 
					"<a target=_blank href='" + item.response.url +"'>" + 
						item.response.name + 
					"</a>";
			});
			return res;
		},
		// 附加信息附件管理
		other_idcard_files_handleFileRemove(file, fileList) {
			this.userInfo_cols.idcard_files = fileList;
		},
		other_idcard_files_handleFilePreview(file) {
		},
		other_idcard_files_handleFileExceed(files, fileList) {
			this.$message.warning(`当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
		},
		other_idcard_files_handleFileSuccess(response, file, fileList) {
			//this.dialogVisibleUploading = false;
			
			this.filesOnUploading = this.filesOnUploading.filter(item => item.name !== file.name);
			if(this.filesOnUploading.length == 0) this.dialogVisibleUploading = false;
			
			if (response.code === 20000) {
				this.userInfo_cols.idcard_files = fileList;
			}
			else
			{
			}
		},
		other_idcard_files_beforeFileRemove(file, fileList) {
			//return this.$confirm(`确定移除 ${ file.name }？`);
		},
		// 文件上传前的验证
		other_idcard_files_beforeUpload(file) {
			// 限制文件大小：500KB = 500 * 1024 bytes
			const isLt500K = file.size / 1024 / 1024 < 200;

			if (!isLt500K) {
				this.$message.error('上传文件大小不能超过 200MB!');
				return false; // 阻止上传
			}
			this.fileOnUploading = file;
			this.dialogVisibleUploading = true;
			this.filesOnUploading.push(file);
			return true; // 允许上传
		},
		other_files_handleFileRemove(file, fileList) {
			this.userInfo_cols.files = fileList;
		},
		other_files_handleFilePreview(file) {
		},
		other_files_handleFileExceed(files, fileList) {
			this.$message.warning(`当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
		},
		other_files_handleFileSuccess(response, file, fileList) {
			//this.dialogVisibleUploading = false;
			
			this.filesOnUploading = this.filesOnUploading.filter(item => item.name !== file.name);
			if(this.filesOnUploading.length == 0) this.dialogVisibleUploading = false;
			
			let itemfiles = [];
			if (response.code === 20000) {
				fileList.forEach( item => {
					let itemfile = {};
					if(item.response && item.raw)
					{
						itemfile.name = item.response.name;
						itemfile.filepath = item.response.filepath;
						itemfile.url = item.response.url;
						itemfile.size = item.raw.size;
						itemfile.type = item.raw.type;
						itemfile.lastModified = item.raw.lastModified;
						itemfiles.push(itemfile);
					}
					else console.log("item:", item);
				});
				this.userInfo_cols.files = fileList;
			}
			else
			{
			}
		},
		other_files_beforeFileRemove(file, fileList) {
			//return this.$confirm(`确定移除 ${ file.name }？`);
		},
		other_files_beforeUpload(file) {
			// 限制文件大小：500KB = 500 * 1024 bytes
			const isLt500K = file.size / 1024 / 1024 < 200;

			if (!isLt500K) {
				this.$message.error('上传文件大小不能超过 200MB!');
				return false; // 阻止上传
			}
			this.fileOnUploading = file;
			this.dialogVisibleUploading = true;
			this.filesOnUploading.push(file);
			return true; // 允许上传
		},
	},
	computed: {
	},
	mutations: {
	}
}
</script>

<style lang="less" Scoped>
.app-regpartner {
	
	.text {
		font-size: 14px;
	}

	.item {
		margin-bottom: 0px;
	}

	.box-card {
		width: 100%;
		max-width: 480px;
	}

	.regbox {
		text-align: left;
		max-width:530px;
		padding: 30px 20px;
		width: 100%;
		/* border-collapse: collapse; */
		border-radius: 8px;
		border: 1px solid rgba(0, 0, 0, 0.10);
		box-shadow: 0 5px 15px rgba(0, 0, 0, 0.09);
		background: #f8f8f8;
		margin-bottom: 40px;
	}
    
    .dialog-footer {
      display: flex;
	  justify-content: flex-end; 
      gap: 12px;
      padding: 0px;
      padding-top: 15px;
      background: #f8f9fa;
      border-top: 1px solid #e9ecef;

		.el-button {
			width: 50%;
			max-width: 135px;
		}
      
      .action-btn {
        flex: 1;
        padding: 12px 20px;
        border-radius: 8px;
        font-weight: 500;
        
        &.recommend-btn {
          background: linear-gradient(45deg, #67C23A, #85ce61);
          color: white;
          border: none;
        }
        
        &.pause-btn {
          background: linear-gradient(45deg, #E6A23C, #ebb563);
          color: white;
          border: none;
        }
        
        &.close-btn {
          background: white;
          color: #606266;
          border: 1px solid #dcdfe6;
        }
      }
    }

	/* 响应式调整 */
	@media (max-width: 768px) {
		.el-form-item__label {
			text-align: left;
		}
		.regbox {
			width: calc(100% - 20px);
		}
	}
}
</style>